import component from './dynamicsSales.vue'

export default component
